import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, Typography, List, ListItem, ListItemButton, ListItemText }from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavItems } from "./useNavItems";

interface Props {
    onLinkClick: () => void;
}

const NavbarItems: React.FC<Props> = ({ onLinkClick }) => {
    const [expandedItem, setExpandedItem] = useState<string | null>(null);
    const items = useNavItems();

    const handleAccordionChange = (label: string) => {
        setExpandedItem(prev => (prev === label ? null : label));
    };

    return (
        <List>
            {items.map((item) =>
                item.children ? (
                    <Accordion
                        key={item.label}
                        expanded={expandedItem === item.label}
                        onChange={() => handleAccordionChange(item.label)}
                        disableGutters
                        elevation={0}
                        sx={{ bgcolor: "transparent" }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{item.label}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ pl: 2, pr: 0, pt: "2px" }}>
                            <List disablePadding>
                                {item.children.map((child) => (
                                    <ListItem key={child.label} disablePadding>
                                        <ListItemButton
                                            component={Link}
                                            to={child.path}
                                            onClick={onLinkClick}
                                            style={{ padding: "6px 16px" }}
                                        >
                                            <ListItemText primary={child.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <ListItem key={item.label} disablePadding>
                        <ListItemButton component={Link} to={item.path!} onClick={onLinkClick}>
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                )
            )}
        </List>
    );
};

export default NavbarItems;
